import React from 'react';
import { NavItem } from './NavItem';
export function Sidebar({
  activePage,
  onNavigate
}: {
  activePage: string;
  onNavigate: (page: string) => void;
}) {
  return <aside className="sticky top-0 flex h-screen w-[300px] flex-col bg-[#111111]" data-id="element-182">
      <div className="h-[80px]" aria-hidden="true" data-id="element-183" />

      <nav className="flex-1 px-8 pb-16 pt-16" aria-label="Primary navigation" data-id="element-184">
        <div className="space-y-8" data-id="element-185">
          <section aria-labelledby="sidebar-focus-heading" data-id="element-186">
            <p id="sidebar-focus-heading" className="mb-3 text-[1.1rem] text-[#7A8290] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)]" data-id="element-187">
              My focus:
            </p>
            <ul className="flex flex-col items-start space-y-6" data-id="element-188">
              <li className="w-full" data-id="element-189">
                <NavItem label="The problem behind the problem" isActive={activePage === 'complexity'} onClick={() => onNavigate('complexity')} data-id="element-190" />
              </li>
              <li className="w-full" data-id="element-191">
                <NavItem label="Turning research into decisions" isActive={activePage === 'research'} onClick={() => onNavigate('research')} data-id="element-192" />
              </li>
              <li className="w-full" data-id="element-193">
                <NavItem label="Building systems that last" isActive={activePage === 'systems'} onClick={() => onNavigate('systems')} data-id="element-194" />
              </li>
            </ul>
          </section>

          <section aria-labelledby="sidebar-case-study-heading" data-id="element-195">
            <p id="sidebar-case-study-heading" className="mb-3 text-[1.1rem] text-[#7A8290] md:text-fluid-lg md:text-[clamp(1.333rem,2vw,1.777rem)]" data-id="element-196">
              My work:
            </p>
            <ul className="flex flex-col items-start" data-id="element-197">
              <li className="w-full" data-id="element-198">
                <NavItem label="Turning rules into a workflow brokers can clear" isActive={activePage === 'work/required-actions'} onClick={() => onNavigate('work/required-actions?from=work')} data-id="element-199" />
              </li>
            </ul>
          </section>
        </div>
      </nav>

      <div className="h-[72px]" aria-hidden="true" data-id="element-200" />
    </aside>;
}